
		<div class="row">
			<div class="col">
				<h3
					*ngIf="options.title"
					class="chart-title-aligment"
				>
					{{ options.title }}
				</h3>
			</div>
			
			<div
				class="col-md-auto"
				*ngIf="isHasData"
			>
				<button
					type="button"
					class="btn btn-outline-success btn-sm"
					[sextant]="'chart-download'"
					(click)="exportData()"
				>
					<i class="fa fa-file-excel" aria-hidden="true">
						<a href="#" #exportFile></a>
					</i>
				</button>
			</div>
		</div>
		
		<chart-filter
			*ngIf="options.isChartFilter"
			[period]="period"
			[filter]="options.filter"
			(onFilterChange)="_onFilterChange($event)"
		></chart-filter>

		<div>
			<div #line [ngStyle]="{display: (options.isLoad ? 'none': '')}"></div>
			<i class="fas fa-volume-mute" *ngIf="isHasData" (click)="hideAllLabels()">&nbsp;</i>
		</div>

		<div
			class="d-flex justify-content-center"
			[ngStyle]="getStyle()"
		>
			<div class="align-self-center">
				<loading
					[isLoad]="options.isLoad"
				></loading>
				
				<span
					*ngIf="! (options.isLoad || isHasData)"
				>
					Ещё нет данных!
				</span>
			</div>
		</div>
	